import { UUID } from "crypto";
import useUserContext from "../Authorization/useUserContext";
import { useQuery } from "@tanstack/react-query";
import { callMRViewTranscripts } from "../../api/dataSources";
import { TMRTranscripts } from "./models";

interface Props {
  studyId: string | UUID;
  respondentId: string;
}

/**
 * Data retriever for a single Study Transcript by Respondent ID
 */
export default function useStudyTranscriptStore({ studyId, respondentId }: Props) {
  const user = useUserContext();

  return useQuery<TMRTranscripts>({
    queryKey: ["pmr:respondent_transcript", studyId, respondentId],
    queryFn: () => callMRViewTranscripts(user, studyId, respondentId),
    retry: (failureCount, error) => {
      // Retry only if failure count is less than 2 and error is not a 404
      if (failureCount >= 2) return false;
      return true;
    },
  });
}
